/* eslint-disable */
import { Component, OnInit } from '@angular/core';
import { NavParams, PopoverController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-delete-reason',
  templateUrl: './delete-reason.page.html',
  styleUrls: ['./delete-reason.page.scss']
})
export class DeleteReasonPage implements OnInit {
  data: any = {};
  survey: any;
  valid = false;
  deleteVal;
  deleteItems = [
    {
      id: 1,
      // text: "I wasn't moving at all. The phone was stationary but still recorded a trip.
      text: this.translate.instant('DELETE_DETAIL_NOT_MOVING')
    },
    {
      id: 2,
      // text: "I was moving but didn't make trip, e.g., I was walking around the yard or inside a building."
      text: this.translate.instant('DELETE_DETAIL_MOVING_A_BIT')
    },
    {
      id: 3,
      // text: "Some other reason, e.g., the times were wrong or the path was wrong or I just don't like it."
      text: this.translate.instant('DELETE_DETAIL_OTHER')
    }
  ];

  constructor(
    private navParams: NavParams,
    private translate: TranslateService,
    private popoverCtrl: PopoverController
  ) {}

  onSelectRadio() {
    this.valid = true;
  }

  onClickItem(id) {
    this.deleteVal = id;
    this.valid = true;
  }

  dismiss() {
    this.popoverCtrl.dismiss(false);
  }

  confirm() {
    this.popoverCtrl.dismiss(this.deleteVal);
  }

  ionViewWillEnter() {
    this.data = this.navParams.data.data;
    this.survey = this.navParams.data.survey;
  }

  ngOnInit() {}
}
